export const FulfillmentProviderIds = {
  MarkedAsShipped: 11,
  AuctaneFulfillment: 20,
  Uber: 143,
};
